import { GetterTree } from 'vuex';
import { IMenuHistoryState } from './types';
import { ILookupResult } from '../shared-types';

const getters: GetterTree<IMenuHistoryState, any> = {
  items(state): ILookupResult[] {
    return state.items;
  },
  selectedResultIndex(state): number {
    return state.selectedResultIndex;
  },
  selectedResult(state): ILookupResult | null {
    return state.items[state.selectedResultIndex];
  },
  cacheSuffix(state): string {
    return state.cacheSuffix;
  },
  mustHaveCacheSuffix(state): boolean {
    return state.mustHaveCacheSuffix;
  },
};

export default getters;
